import { useState } from 'react';
import { Link } from 'react-router-dom';
import { navigationAddresses } from '@/mocks/navigation';
import { categories } from '@/mocks/categories';
import { articles, faqs } from '@/mocks/articles';
import SEOJsonLd, { FAQPageJsonLd } from '@/components/feature/SEOJsonLd';
import HomeHero from './components/HomeHero';
import AddressCard from './components/AddressCard';
import CategoryCard from './components/CategoryCard';
import ArticleCard from './components/ArticleCard';
import FAQItem from './components/FAQItem';

export default function HomePage() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);

  const recentArticles = articles.slice(0, 6);

  return (
    <>
      <SEOJsonLd
        pageType="WebPage"
        pageUrl="/"
        pageTitle="爱情岛论坛网址 - 官方入口导航与最新地址"
        pageDescription="本页专注收录爱情岛论坛网址的最新官方入口，提供稳定可访问的地址导航、最新线路更新与使用指南，帮助用户快速找到爱情岛论坛网址并顺畅访问。"
        dateModified="2026-08-05"
      />
      <FAQPageJsonLd faqs={faqs} />

      <HomeHero />

      <section className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-2 h-6 rounded-full bg-primary-500"></div>
            <h2 className="font-heading text-xl md:text-2xl font-semibold text-foreground-950">
              可用地址导航
            </h2>
            <span className="flex items-center gap-1.5 text-xs text-primary-600 bg-primary-50 px-2.5 py-1 rounded-full">
              <span className="w-1.5 h-1.5 rounded-full bg-green-500"></span>
              全部正常
            </span>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {navigationAddresses.map((addr) => (
              <AddressCard key={addr.id} address={addr} />
            ))}
          </div>
        </div>
      </section>

      <section className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-2 h-6 rounded-full bg-accent-500"></div>
            <h2 className="font-heading text-xl md:text-2xl font-semibold text-foreground-950">
              分类导航
            </h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {categories.map((cat) => (
              <CategoryCard key={cat.slug} category={cat} />
            ))}
          </div>
        </div>
      </section>

      <section className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center justify-between mb-8">
            <div className="flex items-center gap-3">
              <div className="w-2 h-6 rounded-full bg-secondary-500"></div>
              <h2 className="font-heading text-xl md:text-2xl font-semibold text-foreground-950">
                最新文章
              </h2>
            </div>
            <Link
              to="/category/shiyong-zhinan"
              className="text-sm text-primary-500 hover:text-primary-600 font-medium flex items-center gap-1 whitespace-nowrap cursor-pointer"
            >
              查看全部
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line text-xs"></i>
              </div>
            </Link>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {recentArticles.map((article) => (
              <ArticleCard key={article.slug} article={article} />
            ))}
          </div>
        </div>
      </section>

      <section className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
        <div className="max-w-3xl mx-auto">
          <div className="flex items-center gap-3 mb-8 justify-center">
            <div className="w-2 h-6 rounded-full bg-primary-500"></div>
            <h2 className="font-heading text-xl md:text-2xl font-semibold text-foreground-950">
              常见问题
            </h2>
          </div>
          <div className="space-y-3">
            {faqs.map((faq, idx) => (
              <FAQItem
                key={idx}
                faq={faq}
                isOpen={openFaq === idx}
                onToggle={() => setOpenFaq(openFaq === idx ? null : idx)}
              />
            ))}
          </div>
        </div>
      </section>

      <section className="py-14 md:py-20 px-4 md:px-6 relative overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Soft%20warm%20abstract%20gradient%20background%20with%20flowing%20rosy%20pink%20and%20golden%20amber%20tones%2C%20gentle%20organic%20shapes%2C%20clean%20minimal%20aesthetic%2C%20no%20text%2C%20no%20sharp%20lines%2C%20calm%20and%20elegant%20atmosphere%2C%20editorial%20quality%2C%20soft%20diffused%20lighting&width=1600&height=600&seq=home-cta-01&orientation=landscape"
            alt="背景"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
        </div>
        <div className="relative z-10 max-w-2xl mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-3xl font-semibold text-white mb-4">
            找不到正确地址？
          </h2>
          <p className="text-white/80 text-sm md:text-base mb-8 leading-relaxed">
            收藏本站，随时获取爱情岛论坛最新官方入口地址。我们持续监控各线路状态，确保您不会错过任何可用地址。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href="#"
              className="px-6 py-3 bg-primary-500 text-background-50 rounded-lg font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              onClick={(e) => {
                e.preventDefault();
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }}
            >
              查看最新地址
            </a>
            <Link
              to="/category/shiyong-zhinan"
              className="px-6 py-3 bg-white/15 text-white rounded-lg font-medium text-sm hover:bg-white/25 transition-colors whitespace-nowrap cursor-pointer backdrop-blur-sm"
            >
              查看使用指南
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}